import clsx from "classnames";
import { Container } from "react-bootstrap";
import CTABackdrop from "./components/CTABackdrop";
import CTAContent from "./components/CTAContent";
import CTAVisual from "./components/CTAVisual";
import classes from "./styles.module.scss";

/**
 * Call-to-action banner: a white card over a coloured band, with an optional
 * blended background image, decorative curve and overlapping cut-out image.
 *
 * @param {string} [className] - Additional classes for the root element (spacing).
 * @param {string} [bgColor] - Background colour class for the band.
 * @param {string} [shapeColor] - CSS colour for the decorative curve, or "transparent" to hide it.
 * @param {boolean} [emptyCTA] - Strip the white card and visuals, leaving text only.
 * @param {boolean} [showTag] - Whether to show the tag pill.
 * @param {string} [tagText] - Tag pill text.
 * @param {string} [title] - Heading text.
 * @param {string} [description] - Rich text HTML.
 * @param {boolean} [twoColList] - Render lists in the description across two columns.
 * @param {Object} [wideImage] - Blended background image.
 * @param {Object} [personImage] - Overlapping cut-out image.
 * @param {Array} [button] - Button items.
 * @returns {JSX.Element}
 */
export const CTABanner = ({
  className = "py-5",
  bgColor = "bg-primary",
  shapeColor = "var(--bs-senary)",
  emptyCTA = false,
  showTag = false,
  tagText,
  title,
  description,
  twoColList = false,
  wideImage,
  personImage,
  button,
}) => {
  const isCard = !emptyCTA;
  const buttons = Array.isArray(button) ? button : button ? [button] : [];

  return (
    <div data-component="CTABanner" className={clsx(className, bgColor, classes.ctaBanner)}>
      <Container className="mw-xxl">
        <div className={clsx(classes.ctaBanner__card, { [classes["ctaBanner__card--empty"]]: !isCard })}>
          {isCard && <CTABackdrop wideImage={wideImage} />}

          <div className={classes.ctaBanner__inner}>
            <CTAContent
              showTag={showTag}
              tagText={tagText}
              title={title}
              description={description}
              buttons={buttons}
              twoColList={twoColList}
              fullWidth={!isCard}
            />

            {isCard && <CTAVisual shapeColor={shapeColor} personImage={personImage} />}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CTABanner;
